import ODALogo from "../assets/logos/oda_logo.svg"
import ComunidadEnRetornoLogo from "../assets/logos/comunidad-en-retorno.png"
import CoalitionMigrantsChicago from "../assets/logos/coalition-migrant-mx.png"
import tarjetaVerde from '../assets/Tarjeta-Verde_know-your-rights-in-mexico.jpg'

export const es_MX = {
    "title": "Know Your Rights in Mexico",
    "subtitle": "From MX to the US, you are not alone!",
    "blurb": "There is a community that has been organizing and navigating life in the aftermath of deportation and forced return. ",
    "campaignName": "Tarjeta Verde",
    "description": "The Tarjeta Verde is meant to provide essential information to Mexican citizens who find themselves back in Mexico after deportation or forced return.",
    "description2": "Despite the rising fear in immigrant communities, from the learnings within our work of accompaniment of deportees & returnees in the last decade, we know that information can bring essential orientation, preparedness, and extend an embrace to people who feel they are the only ones.",
    printTitle: "Print at home",
    "print": [{
        "language": "Español",
        "fileName": 'Print Your Own "Tarjeta Verde" Cards',
        "link": "https://drive.google.com/file/d/1a3_HbHXKw8USYQ4prryr7y-x38hg_M5l/view?usp=sharing"
    }, {
        "language": "English",
        "fileName": 'Print Your Own "Tarjeta Verde" Cards',
        "link": "https://drive.google.com/file/d/1yshdD73euugTp_yuQ5UJWqXAb2QzDb-y/view?usp=sharing",
    }, {
        "language": "Tzotzil",
        "fileName": 'Print Your Own "Tarjeta Verde" Cards',
        "link": "https://drive.google.com/file/d/1bpMXHPCoK82UZmbvSAA0q9S6cyz0Duwg/view?usp=sharing",
    }],
    "about": {
        "title": "About the campaign",
        subtitle: "Campaign",
        "objective": {
            "title": "Objective",
            "tool": "We hope these tools will let others know:",
            "points": {
                "1": "You have rights in Mexico, some that you can access in the United States and others that should be respected if you find yourself back in Mexico, even when institutions try to deny them.",
                "2": "Information is key. In the face of fear, we respond with information.",
                "3": "You are not alone, there is a community that has been organizing and learning to navigate life in the aftermath of deportation and forced return.",
            },
            "to": "To",
            "toPoints": {
                "1": "Prevent our returnee and deportee community from falling through the cracks.",
                "2": "Reduce human rights violations.",
                "3": "Strengthen relationships with pro-immigrant organizations on both sides of the Mexico-U.S. border. "
            }
        },
        "howToUse": {
            title: "Use",
            subtitle: "How to use the card:",
            "usa": {
                subtitle: "In the U.S.,",
                "description": " it is a bridging tool for organizations, lawyers & individuals to provide resources to those facing a possible forced return or deportation.",
                "description2": "This is an informational and preventative tool."
            },
            "mexico": {
                subtitle: "In Mexico,",
                "description": "this card will be “activated”. It provides essential information for the first moments upon arriving in Mexico, a moment we know can be filled with fear.",
                "description2": "Deportees and returnees will have access to the direct numbers of ODA, as well as Comunidad en Retorno, and a database of other organizations that can accompany them in the journey ahead."
            },
            image: tarjetaVerde
        },
        "callToAction": {
            "title": "Join",
            "subtitle": "Join efforts from both sides of the border!",
            "whoCanJoin": "Are you an organization, network, lawyer or community organizer? Join the Directory & Translocal Corridor of Accompaniment. \n\nLet’s talk.",
            "howToHelp": ["Spread the word!",  "Re-share on social media",  "Print and share in the United States & Mexico.", "Donate to the campaign."]
        }
    },
    "donate": {
        "title": "Donate!",
        "link": "https://www.paypal.com/donate/?hosted_button_id=GY3U6M2DSQVZW"
    },
    "mediaKit": {
        "title": "Learn more about the campaign",
        "link": "https://drive.google.com/file/d/1e9BQpm5H_1risYSsvrR2vaN_LbSHpwoc/view"
    },
    callToAction: {
        title: "Get Involved!",
        link: "https://forms.gle/3jJqN3vZMtBh4wNi8"
    },
    "directory": {
        "title": "Support Directory",
        "description": "In the aftermath of deportation and forced return we’ve learned the experience is intergenerational and diverse.",
        "description2": "Find here more tools and diverse guides about navigating life back in Mexico!"
    },
    "partners": {
        title: "Partners",
        description: "In collaboration with Comunidad en Retorno, Otros Dreams en Acción, and the Coalición de Migrantes Mexicanos, through the example of the Red Card created by Immigrant Legal Resource Center (ILRC) we are designing tools to “Know Your Rights in Mexico”.",
        list: [
            {
                "title": "Otros Dreams en Acción",
                "about": "Otros Dreams en Acción (ODA) is an organization led by returned and deported migrants, seeking alliances with other social sectors to overcome challenges and transform policies affecting return migration and deportation in Mexico from a human rights perspective.",
                logo: ODALogo,
                socials: {
                    instagram: "https://www.instagram.com/otros_dreams_en_accion",
                    facebook: "https://www.facebook.com/OtrosDreams",
                    youtube: "https://www.youtube.com/@odaotrosdreamsenaccion6686",
                    website: "http://www.odamexico.org"
                }
            },
            {
                "title": "Comunidad en Retorno",
                "about": "Comunidad en Retorno is a collective group formed by people from the returned or deported community and Mexican people related to the return migration process.",
                logo: ComunidadEnRetornoLogo,
                socials: {
                    instagram: "https://www.instagram.com/comunidadenretorno/",
                    facebook: "https://www.facebook.com/p/Comunidad-en-retorno-100071424504267/",
                    youtube: "https://www.youtube.com/@comunidadenretorno8174"
                }
            },
            {
                "title": "Mexican Migrant Coalition",
                "about": "Our objective is to fortify bonds with migrants and their country of origin to impact and better their lives on a local level.",
                logo: CoalitionMigrantsChicago,
                socials: {
                    facebook: "https://www.facebook.com/CoalicionDeMigrantesMexicanos",
                }
            }
        ],
        morePartnersTitle: "More Partners",
        thanks: "Thank you to all the organizations that have accompanied us in this process!",
    },
    faq: {
        title: "Common Questions",
        subtitle: "Frequently asked questions",
        description: "",
        questions: [{
            question: "What is a Deportee?",
            answers: [
                "Here we have two types of deportees, those who were strictly deported and those who, through coercion, may not recognize that they have lived a deportation. It is important to remember that, in its origin, immigration law is just administrative; it does not intrinsically imply any conflict with criminal systems, like the deportation machine has led us to believe. In essence, an administrative breach, like running a red light and undocumented presence, would be on the same level.",
                "Whenever a person is strictly deported, this means they have been subjected to an administrative process, where they have been in custody of an administrative immigration authority and have undergone a process to be deported. In an image, these are our community members who are pictured shackled by ICE as they are handed over to the Mexican government.",
                "As far as being deported in a broad sense, this includes any person who has undergone an administrative process to be removed or to be forced out of the country, even if they were not escorted out. An example of this is voluntary departure, which entails coercing a person into signing a document saying that they will leave the country on their own means."
            ]
        }, {
            question: "What is a Returnee/Forced Returnee?",
            answers: ["Under the theory of immigration, many have named our experience as voluntary. But how can we freely choose when living in a country that illegalizes and actively persecutes us? The active fear campaign stemmed from both the republican and democratic parties, having built a deportation machine that is fueled by the criminalization and dehumanization of immigrant communities. This leads to a forced return, or as we hear today, to “self-deport”. Forcing immigrants and their families to leave the United States for countries such as, but not limited to, Mexico. However, we stick to the terminology of returnee or forcibly returned to amplify the truth; there are other violences outside the deportation machine that force our communities to live in exile, such as a lack of housing, education, food, and an overall dignified life."]
        }, {
            question: "What is the Certificate of Reception for Repatriated Mexicans used for?",
            answers: ["We advise you to NOT throw away your Hoja de repatriación",
                "This document serves as identification in case you do not have any official ID.",
                "It will help you board the bus and participate in various programs for repatriated individuals at your destination.",
                "The validity of the certificate will depend on the program you wish to participate in.",
                {
                    text: "With it, you can collect your money transfers at TELECOMM offices according to the directory at the end of this ",
                    prompt: ' Guide',
                    url: "https://www.gob.mx/cms/uploads/attachment/file/45147/GUIA_SOMOS_MEXICANOS_PRIM.pdf"
                },
                'Note: Some of the information is no longer up to date due to the implementation of the "Mexico te abraza" program.'
            ]
        }, {
            question: "How do I get my INE?",
            answers: [
                {
                    text: "In Mexico, check the process here: ",
                    prompt: " https://ine.mx/credencial",
                    url: "https://ine.mx/credencial"
                },
                {
                    text: "Abroad, check the process: ",
                    prompt: " Here!",
                    url: "https://consulmex.sre.gob.mx/austin/index.php/documentacion/credencial-para-votar-en-el-extranjero"
                },
                "It is an official identification that guarantees Mexican citizenship and is the credential to vote in Mexico. It has become one of the most important documents that at times when there is an electoral ban has caused returnees to be “undocumented” in Mexico, since this credential is requested for most processes such as employment, rent and even to enter some buildings.",
                "If you already have it with residency abroad, once in Mexico you will have to apply for it again since it is usually rejected.",
                "In Mexico: If you do not have a proof of address for the INE process and you are in the CDMX we can help you with witnesses.",
                {
                    text: "Learn what an electoral ban is: ",
                    prompt: "INE Veda Electoral",
                    url: "https://youtu.be/FKh2HgknzXg?si=GiaYt-SU1aEebhaI"
                },
                "If you are unable to access your INE, contact us at retornodigno@odamexico.mx."]
        }, {
            question: "How can I get my birth certificate?",
            answers: [
                {
                    text: "This is a process that can be done from abroad. ",
                    prompt: "Apply here",
                    url: "https://www.gob.mx/ActaNacimiento"
                },
                "In order to complete the process you will need to have at hand the Clave Única de Registro de Población (CURP), full name, date of birth, entity of registration, sex and affiliation data (full name of mother, father or person who registered you).",
                "The majority of Actas de Nacimientos were uploaded to a digital platform where anyone can search and print, sometimes an Acta de Nacimiento might not be in the system.",
                "If you are in the United States, we would recommend visiting your nearest Mexican Consulate.",
                {
                    prompt: "Check the cost per state",
                    url: "https://www.gob.mx/tramites/ficha/expedicion-de-la-copia-certificada-del-acta-de-nacimiento-en-linea/RENAPO187"
                },
                "If you are in Mexico or unable to access support, contact us at retornodigno@odamexico.mx."
            ]
        }, {
            question: "What is a CURP and how do I find mine?",
            answers: [
                {
                    text: "This is a process you can do from abroad. - Process it here: ",
                    prompt: "https://www.gob.mx/curp/",
                    url: "https://www.gob.mx/curp/"
                },
                "It is an 18-character alphanumeric code used to identify persons residing in Mexico, regardless of their nationality. It is a fundamental instrument to register individually all the inhabitants of the country and Mexicans residing abroad.",
                "In other words: Although in Mexico there is another system called social security, the CURP is like a “social security number/ número de seguridad social” from the United States.",
                {
                    prompt: "More information",
                    url: "https://www.gob.mx/segob/acciones-y-programas/clave-unica-de-registro-de-poblacion-curp"
                },
                "To request telephone assistance about the CURP service, you can contact the Attention and Service Center, Monday through Friday, from 8:00 a.m. to 4:00 p.m., at the following telephone numbers: 800 9 11 11 11, extensions 15100 and 1510.",
                "If you are unable to access your CURP in Mexico, please contact us at retornodigno@odamexico.mx."
            ]
        }]
    }
}

export default es_MX;